import fetchAPI from '../utils/fetchApi';

type TArgs = {
  feedOptions: {
    feedType: string;
    postcode?: string;
    offset?: number;
    limit?: number;
    asListings?: boolean;
  };
  xsrfToken: string;
};

export default ({ feedOptions: { feedType, postcode, offset, limit, asListings }, xsrfToken }: TArgs) =>
  fetchAPI({
    method: 'POST',
    url: '/lp/api/feed-items',
    // @ts-expect-error -- fetchApi payload param typed as null by default in JS source
    payload: {
      feedType,
      postcode,
      offset,
      limit,
      asListings,
    },
    xsrfToken,
  });
